
import {
  Body,
  Card,
  Date,
  Degree,
  Description,
  Grade,
  EducationImage,
  Name,
  Span,
  Top,
} from "./EducationCardStyles";

const EducationCard = ({ education }) => {
  return (
    <Card>
      <Top>
        <EducationImage src={education.img} />
        <Body>
          <Name>{education.school}</Name>
          <Degree>{education.degree}</Degree>
          <Date>{education.date}</Date>
        </Body>
      </Top>
      <Grade>
        <b>Grade: </b>
        {education.grade}
      </Grade>
      <Description>
        <Span>{education.desc}</Span>
      </Description>
    </Card>
  );
};

export default EducationCard;
